
import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import 'react-day-picker/lib/style.css';
import { faHandPointer, faExclamationTriangle, faTrash } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-day-picker/lib/style.css';
import { css } from 'react-emotion';
// First way to import
import { Redirect } from 'react-router-dom';
import MainLayout from '../layout/layout';
import RolesType from '../utils/roles';
import { ClipLoader } from 'react-spinners';
import FingerPrintService from '../Services/FingerPrintService/fingerPrintService';
import CustomerInfoService from '../Services/CustomerInformationService/customerInformationService';
import CompanyLocationService from '../Services/CompanyLocationService/CompanyLocationService';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class FingerPrint extends Component {
    constructor(props) {
        super();
        this.state = {
            UserData: { pending: false, value: [] },
            totalCount: 0,
            page: 1,
            maxPerPage: 10,
            Filter: {
                FilterUserName: "",
                FilterCompanyCode: "",
                FilterAction: "",
                FilterStartDate: "",
                FilterEndDate: "",
                FilterUserID: "",
                FilterLocation : ""
            },
            modal: {warning: false, success: false},
            idAudit: null,
            loading: false,
            SelectActions: "",
            ActionsList: [],
            Button: <a className="btn btn-warning">OK</a>,
            UserIDList: null, 
            FingerPrintList: null,
            CompanyCode: "",
            MaxUser: "",
            ProductCode: "",
            UsersActive: "",
            ExpirationDate:"",
            LocationData: { pending: false, value: [] },
            SelectLocations: "",
            messageDelete:"",
            isAutenticated: true
        };
        this.hanldeKeyPress = this.hanldeKeyPress.bind(this);
        this.companyCodeValue = this.companyCodeValue.bind(this);
        this.userIDValue = this.userIDValue.bind(this);
        this.locationValue = this.locationValue.bind(this);
        this.hanldeKeyPressCompanyCode = this.hanldeKeyPressCompanyCode.bind(this);
        this.toggleWarning = this.toggleWarning.bind(this);
        this.getCustomerInfo = this.getCustomerInfo.bind(this);
        this.handleLocations = this.handleLocations.bind(this);
    }      
    toggleWarning(e) {
        this.setState({
            modal: { warning : !this.state.modal.warning, success: false},               
        });       
    }
    
    handleLocations(event) {
        var value = event.target.value;

        if (value !== "0") {
            // var location_list = this.state.LocationData.value;
            // var location = location_list.find(x => x.COMPANY_LOCATION_CODE === value);            
            this.setState({
                SelectLocations: value,
            }, ()=> this.getUserBiometricResult());            
        }
        if(value === "0")
        {
            this.setState({
                SelectLocations: "",
            }, ()=> this.getUserBiometricResult());   
        }
    }
    setOperation(e, UserIDList, FingerPrintList, operations) {

        if(operations === "DELETE_ALL"){
            var UserList = this.state.UserData.value;
            var UserIDLisT = UserList.map(a=>a.UserID);
            this.setState({
                Button:<a className="btn btn-warning" onClick={(e)=>{this.DeleteByFingerPrint(e)}}>OK</a>,
                loading: false,
                UserIDList:UserIDLisT,
                FingerPrintList: FingerPrintList,
                messageDelete: "Do you want to delete all FingerPrints for all User?" 
            });    
            this.toggleWarning(e);       
        }else if(operations === "DELETE"){
            this.setState({
                Button:<a className="btn btn-warning" onClick={(e)=>{this.DeleteByFingerPrint(e)}}>OK</a>,
                loading: false,
                UserIDList:UserIDList,
                FingerPrintList: FingerPrintList,
                messageDelete: "Do you want to delete this FingerPrints for this User?"
            });       
            this.toggleWarning(e);    
        }else if(operations === "DELETE_ALL_BY_USER"){
            this.setState({
                Button:<a className="btn btn-warning" onClick={(e)=>{this.DeleteByFingerPrint(e)}}>OK</a>,
                loading: false,
                UserIDList:UserIDList,
                FingerPrintList: FingerPrintList,
                messageDelete: "Do you want to delete all FingerPrints for this User?"
            });       
            this.toggleWarning(e);    
        }         
    }    
    DeleteByFingerPrint(){
        var UserList = this.state.UserIDList;
        var FingerList = this.state.FingerPrintList;
        var location = this.state.Filter.FilterLocation;
        var Companycode = this.state.Filter.FilterCompanyCode;
        var User = this.state.Filter.FilterUserID;
        var Email = sessionStorage.getItem('email');
        var that = this;
        var DataResult = FingerPrintService.DeleteFingerPrint(UserList, FingerList, Companycode, Email);
        that.setState({
            loading: true
        });
        if(Companycode === "")
        {
            that.setState({
                modal: { success: false, id: null, add: false, warning: false },
                loading: false,
            });
            toast.warning("You must to select a Company Code!", { className: {
                opacity: 0.8
            }});
            return false;    
        }
        DataResult.then(function (data) {
            if (data.data === "OK") {               
                that.setState({
                    modal: { success: false, id: null, add: false, warning: false },
                    loading: false,
                    UserIDList:"",
                    FingerPrintList: "" ,
                    messageDelete:""
                });
                that.getUserBiometric(1, 10, Companycode, User, location); 
                toast.success("Deleted", {
                    className: {
                        opacity: 0.8
                    }
                });
            }else if (data.data === "No") {
                that.setState({
                    modal: { success: false, id: null, warning: false },
                    loading: false,
                    UserIDList:"",
                    FingerPrintList: "",
                    messageDelete:"" 
                });
                toast.error("Operations Error!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                loading: false,
                modal: { warning: false },
                UserIDList:"",
                FingerPrintList: "",
                messageDelete:"" 
            });
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }
    companyCodeValue(e) {
        e.preventDefault();               
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterCompanyCode = e.target.value;
        this.setState(stateCopy);
    }
    userIDValue(e) {
        e.preventDefault();  
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterUserID = e.target.value;
        this.setState(stateCopy);
        
    }
    locationValue(e) {
        e.preventDefault();               
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterLocation = e.target.value;
        this.setState(stateCopy);
    }
    hanldeKeyPress(e){

        var CompanyCode = this.state.Filter.FilterCompanyCode;
      
        if(e.keyCode === 13){
            if(CompanyCode !== ""){ 
                this.getUserBiometricResult(); 
            }else{
                toast.error("CompanyCode cant not be Empty!", { className: {
                    opacity: 0.8
                }});
            }                  
        } 
    }
    getCustomerInfo(){
        var CompanyCode = this.state.Filter.FilterCompanyCode;
        var email = sessionStorage.getItem('email');
        var that = this;
        this.setState({
            loading: true
        });
        var DataResult = CustomerInfoService.getCustomerInformation( CompanyCode, email);          
        DataResult.then(function(data){
            if(data.statusText === "OK" && data.data !== "NoDB" && data.data !== "NotFound"){               
              that.setState({
                 CompanyName: data.data.CompanyName,
                 MaxUser: data.data.MaxUsers,
                 ProductCode: data.data.ProductCode,
                 UsersActive: data.data.UsersActive,
                 ExpirationDate: data.data.ExpirationDate,                 
                 loading: false
              });            
            }
        }).catch((error) => {

            that.setState({
                CompanyName: "",
                MaxUser: "",
                ProductCode: "",
                UsersActive: "",
                ExpirationDate: "",                 
                loading: false
             });
             if(error.response)
             {
                 if(error && error.response && error.response.data.Message === "500") {               
                     toast.error("Error Data Base(Error: 500)", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NotReseller") {    
                    toast.error("This User does not have permission!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data.Message === "400"){ 
                    toast.error("API Error for Reseller", { className: {
                        opacity: 0.8
                    }});
                 }else if(error.response.status === 401){ 
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();  
                        this.setState({ isAutenticated: false },
                        ()=>{                               
                            this.forceUpdate();
                        })              
                 }   
             }else{
                 toast.error("Code Error", { className: {
                     opacity: 0.8
                 }});
             }
        });        
    }
    hanldeKeyPressCompanyCode(e){
        var CompanyCode = this.state.Filter.FilterCompanyCode;
        if(e.keyCode === 13){
            if(CompanyCode !== ""){ 
               this.getCustomerInfo(); 
               this.getUserBiometricResult();  
               this.getAllLocation();              
            }else{
                toast.warning("CompanyCode cant not be Empty!", { className: {
                    opacity: 0.8
                }});
            }                
        }      
    }
    getAllLocation(){
        var Companycode =  this.state.Filter.FilterCompanyCode;
        var Email = sessionStorage.getItem('email');
        let dataResult = CompanyLocationService.getAllLocation(Companycode,Email);
        var that = this;
        dataResult.then(function (data) {
            if(data.statusText === "OK"){
                that.setState({
                    LocationData: { pending: false, value: data.data }
                });
            }
        }).catch((error) => {
            that.setState({
                LocationData: { pending: false, value: []}
            });            
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }
    getUserBiometric(page, maxPerPage, Companycode, UserID, CompanyLocation){

        var Email = sessionStorage.getItem('email');     
        this.setState({
            UserData: { pending: true, value: [] },
            totalCount: 0,
            page: 1
        });
        let dataResult = FingerPrintService.getUserBiometric(page, maxPerPage, Companycode, UserID, CompanyLocation, Email);
        var that = this;
        dataResult.then(function (data) {
            if(data.statusText === "OK" && data.data !== "NoDB"){
                that.setState({
                    UserData: { pending: false, value: data.data.UserFingerPrintLs },
                    totalCount: parseInt(data.data.UserFingerPrint_Total_Count,10),
                    page: data.data.npage
                });
            }
        }).catch((error) => {
            that.setState({
                UserData: { pending: false, value: [] },
                totalCount: 0,
                page: 1
            });
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }
    getUserBiometricResult(){
      
        var Email = sessionStorage.getItem('email');
        var LocationCode= this.state.SelectLocations;        
        this.setState({
            UserData: { pending: true, value: [] },
            totalCount: 0,
            page: 1
        });
        let dataResult = FingerPrintService.getUserBiometric(1, 10, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserID,LocationCode, Email);
        var that = this;
        dataResult.then(function (data) {
            if(data.statusText === "OK" && data.data !== "NoDB" && data.data !== "NotFound"){
                that.setState({
                    UserData: { pending: false, value: data.data.UserFingerPrintLs },
                    totalCount: parseInt(data.data.UserFingerPrint_Total_Count,10),
                    page: data.data.npage
                });
            }
        }).catch((error) => {            
            that.setState({
                UserData: { pending: false, value: [] },
                totalCount: 0,
                page: 1
            }); 
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }
    truncate(value) {
        if (value)
            var res = value.slice(1, 30);

        return res + "...";
    }
    getPrevPage(currentPage, maxPerPage) {
        if (parseInt(maxPerPage >= this.state.totalCount, 10))
            return 0;
        else
            return currentPage - 1;
    }
    getNextPage(currentPage, maxPerPage) {
        if ( parseInt( this.state.totalCount / maxPerPage, 10) === currentPage && parseInt(this.state.totalCount % maxPerPage, 10) === 0)
            return 0;
        else if ( parseInt(this.state.totalCount / maxPerPage, 10) === currentPage - 1 && parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return 0;
        else
            return currentPage + 1;
    }
    getPagesCount(maxPerPage) {
        if (parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return (this.state.totalCount / maxPerPage) + 1;
        else
            return this.state.totalCount / maxPerPage;
    }
    renderPages() {
        
        let pages = [];
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let pagesShow = pagesCount > 5 ? 5 : this.getPagesCount(this.state.maxPerPage);
        let startPagination = pagesCount <= 5 ? 1 : (this.state.page - 3 <= 0 ? 1 : (this.state.page + 2 > pagesCount ? pagesCount - 4 : this.state.page - 2));
        for (let i = startPagination; i <= startPagination + pagesShow - 1; i++) {
            pages.push(<li key={i} className={this.state.page === i ? "page-item active" : "page-item"} onClick={(event) => {
                event.preventDefault(); this.getUserBiometric(i, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserID,
                    this.state.Filter.FilterLocation)
            }}><a className="page-link">{i}</a></li>);
        }
        return pages
    }
    renderNextPage() {
        let next_page = this.getNextPage(this.state.page, this.state.maxPerPage);
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let nextpages = [];
        if (next_page !== 0) {
            nextpages.push(<li key="Next" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getUserBiometric(next_page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserID,
                    this.state.Filter.FilterLocation)
            }}>
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="Last" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getUserBiometric(pagesCount, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserID,
                    this.state.Filter.FilterLocation)
            }}>
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        else {
            nextpages.push(<li key="NextP" className="page-item disabled">
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="LastP" className="page-item disabled">
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        return nextpages;
    }
    renderFirstPage() {
        let prev_page = this.getPrevPage(this.state.page, this.state.maxPerPage);
        let prevpages = [];
        if (prev_page !== 0) {
            prevpages.push(<li key="FirstT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getUserBiometric(1, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserID,
                    this.state.Filter.FilterLocation)
            }}>
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstTT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getUserBiometric(prev_page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserID,
                    this.state.Filter.FilterLocation)
            }}>
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        else {
            prevpages.push(<li key="FirstPP" className="page-item disabled">
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstPPP" className="page-item disabled">
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        return prevpages;
    }

    FingerPrintTotal( UserID, FingerList){

        let a = [];
        FingerList.forEach(element => {
            if(element.Finger > 0)
            {
                if(element.isValid === true){
                    a.push(<a onClick={(e) => this.setOperation(e, UserID, element.Finger, "DELETE")}
                            style={{ 'paddingLeft': '10px','fontSize': '20px','position': 'relative' ,'top': '-5px'}} key={element.Finger + 0.15}>
                            <Badge color="success" >{ element.Finger }</Badge>
                          </a>);   
                }else{
                    a.push(<a onClick={(e) => this.setOperation(e, UserID, element.Finger, "DELETE")}
                    style={{ 'paddingLeft': '10px','fontSize': '20px','position': 'relative' ,'top': '-5px'}} key={element.Finger + 0.15}>
                    <Badge color="warning" >{ element.Finger}</Badge>
                  </a>);  
                }   
            }         
        });
          return a;
    }  
    renderAuditRow()
    {           
        let optionItemsLocation = this.state.LocationData.value.map((item, index) => {
            return <option key={item.COMPANY_LOCATION_CODE} className="dropdown-item" href="#" value={item.COMPANY_LOCATION_CODE}>{item.NAME}</option>
        });

        let dataResult = RolesType;
        var temp = Object.keys(dataResult);    
        if(sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[2] ||  sessionStorage.getItem("rol") === temp[4] ||
           sessionStorage.getItem("rol") === temp[5])
        {
            return (<div>
                      <div className="row">
                        <div className="col s12">
                            <div className="card Logs">
                                <div className="card-header">
                                    <div className="row" id="timelogs_filter">
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{'fontWeight': 'bold'}}>UserID</label>
                                            <div className="form-group">
                                                <input className="form-control" name="userId" id="userId" type="text" onKeyDown={this.hanldeKeyPress} onChange={this.userIDValue} value={this.state.Filter.FilterUserID} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3">
                                            <label className="control-label" style={{'fontWeight': 'bold'}}>Location</label>
                                            <div className="form-group">
                                                <select className="form-control" onChange={this.handleLocations} value={this.state.SelectLocations}>
                                                    <option className="dropdown-item" href="#" value="0" >Select</option>
                                                    {optionItemsLocation}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3">
                                            <div className="form-group" style={{ 'paddingTop': '26px', 'marginBottom': '0rem' }}>
                                                <a className="btn btn-danger" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.setOperation(e, "", "", "DELETE_ALL")}><FontAwesomeIcon icon={faTrash} />&nbsp;&nbsp;DELETE ALL FINGERPRINT</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <table className="table table-hover table-striped table-sm myTable">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>User ID</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>First Name</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Last Name</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Location</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>FingerPrint</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Actions</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.UserData.pending
                                                    ? <tr><td colSpan="7"><span className="loader"></span></td></tr>
                                                    : this.state.UserData.value.map((item, index) => {
                                                        return <tr key={index} >
                                                                    <td style={{'fontWeight': '400'}}>{item.UserID}</td>
                                                                    <td style={{'fontWeight': '400'}}>{item.FirstName}</td>
                                                                    <td style={{'fontWeight': '400'}}>{item.LastName}</td>
                                                                    <td style={{'fontWeight': '400'}}>{item.Location}</td>
                                                                    <td style={{'fontWeight': '400'}}>{ this.FingerPrintTotal(item.UserID, item.Finger)}</td>
                                                                    <td> 
                                                                        {
                                                                            item.CantFingerPrint > 0
                                                                            &&
                                                                            <a style={{ 'paddingLeft': '10px', 'fontSize': '15px'}}onClick={(e) => this.setOperation(e, item.UserID,  item.Finger.map(a=>a.Finger), "DELETE_ALL_BY_USER")}><Badge color="danger"><FontAwesomeIcon  icon={faHandPointer} size="lg"/></Badge></a>
                                                                        }
                                                                    </td>
                                                                    <td></td>
                                                                </tr>;
                                                    })
                                            }
                                        </tbody>
                                    </table>
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            {this.renderFirstPage()}
                                            {this.renderPages()}
                                            {this.renderNextPage()}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>);
        }else{
            return (<Redirect to={'/login'}/>)
        }
    }
    ValidateDate(d){

        var ActualDate             = new Date();
        var DBDate = new Date(d);
        
        // Compara solo las fechas => no las horas!!
        ActualDate.setHours(0,0,0,0);

        let ret =  DBDate < ActualDate ? "badge badge-pill badge-danger": "badge badge-pill badge-light";        
        return ret;

    }
    ValidateMaxUser(MaxUser, ActiveUsers){             
        let ret =  MaxUser < ActiveUsers ? "badge badge-pill badge-danger": "badge badge-pill badge-light";        
        return ret;
    }
    renderCustomerInformation(){
        return (<div>
            <div className="card Logs">
            <div className="card-body">                
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Customer Information</span></h4>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 offset-md-1" style={{'paddingBottom': '0.8rem', 'paddingRight': '1.8rem', 'textAlign': 'right'}}>
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Company Code</label>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 " style={{'paddingBottom': '0.8rem'}}>
                                 <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                    <input className="form-control" name="CompanyCode" id="CompanyCode" type="text" onKeyDown={ this.hanldeKeyPressCompanyCode}  onChange={this.companyCodeValue} value={this.state.Filter.FilterCompanyCode ? this.state.Filter.FilterCompanyCode : ""}/>
                                 </div>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 " style={{'paddingBottom': '0.8rem'}}>
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loading}
                                />
                            </div>
                        </div>
                        <div className="row">                                 
                            <div className="col-3" style={{'paddingBottom': '0.8rem'}}>
                                <span className="badge badge-pill badge-light">Company Name: {this.state.CompanyName}</span>
                            </div>                        
                            <div className="col-3" style={{'paddingBottom': '0.8rem'}}>
                                <span className="badge badge-pill badge-light">Max Users: {this.state.MaxUser}</span>
                            </div>
                            <div className="col-3" style={{'paddingBottom': '0.8rem'}}>
                                 <span className={this.ValidateMaxUser(this.state.MaxUser,this.state.UsersActive)} >Users Active: {this.state.UsersActive}</span>
                            </div>
                        </div>
                        <div className="row">                           
                            <div className="col-3 offset-md-3">
                                <span className="badge badge-pill badge-light">Product Code: {this.state.ProductCode}</span>
                            </div>
                            <div className="col-3">
                            <span className={this.ValidateDate(this.state.ExpirationDate.replace("T" , " "))} >Expiration Date: {this.state.ExpirationDate.replace("T" , " ")}</span>
                            </div>
                        </div>
                    </div>
            </div>

        </div>);
   
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        return (
            <div>
                <MainLayout /><ToastContainer hideProgressBar/>
                <div className="container">
                  
                   {
                       this.renderCustomerInformation()                    
                   }<br/>
                   {
                       
                       this.renderAuditRow()
                   }
                    <Modal isOpen={this.state.modal.warning} toggle={this.toggleWarning}
                    
                   
                   aria-labelledby="contained-modal-title-lg"
                   className={"modal-dialog modal-notify modal-warning"}
               >
                   <ModalHeader toggle={this.toggle}> <p className="heading lead">Warning</p>
                       </ModalHeader>
                   <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                         <p><FontAwesomeIcon color="#FFBB33"  icon={faExclamationTriangle} size="3x" /></p>
                         <p>{this.state.messageDelete}</p>
                   </ModalBody>
                   <ModalFooter className={"modal-footer justify-content-right"}>
                   <ClipLoader
                       className={override}
                       sizeUnit={"px"}
                       size={30}
                       color={'#FF8800'}
                       loading={this.state.loading}
                   />
                       { this.state.Button }
                       {
                           this.state.loading
                           ? <a className="btn btn-outline-warning waves-effect disabled" onClick={this.toggleWarning } disabled>CLOSE</a>
                           : <a className="btn btn-outline-warning waves-effect" onClick={this.toggleWarning}>CLOSE</a>
                        }
                   </ModalFooter>
               </Modal>
                </div>
            </div>
        );
    }
   
}
export default FingerPrint;


// WEBPACK FOOTER //
// ./src/fingerPrint/fingerPrint.jsx